import {setType} from '../../redux/slices/AslSlice';
export const ext = {
   audio: ['mp3', 'wav'],
   video: ['mp4', 'm4v'],
};

export function getFileExtension(filename) {
   return filename.split('.').pop();
}

export function getMediaType(url, dispatch) {
   const fileExt = getFileExtension(url);
   const fileType = ext['audio'].includes(fileExt)
      ? 'audio'
      : ext['video'].includes(fileExt)
      ? 'video'
      : null;
   //return fileType;
   dispatch(setType(fileType));
}
